import React from "react";
import "./WhyChooseUs.css"; // Custom CSS for styling
import { FaBookmark, FaDollarSign, FaHeadset, FaSuitcase } from "react-icons/fa"; // Icons from react-icons
import bgTop from '../../img/about-bg-stars-top.png'; // Replace with the correct image path
import bgBottom from '../../img/about-bg-stars-bottom.png'; // Replace with the correct image path




const WhyChooseUs = () => {
  return (
    <div className="why-choose-us-container">
        

      <h2>
        Why Choose <span className="highlight">Us?</span>
      </h2>
      <div className="bg-star-top">
            <img src={bgTop} alt="" />
        </div>
      <div className="cards-container">
        <div className="card-a">
          <div className="icon-wrapper-a">
            <FaBookmark className="icon-a" />
          </div>
          <h3>Convenience</h3>
          <p>
            Plan your entire trip from one platform, saving you time and effort.
            No more hopping between different websites.
          </p>
        </div>
        <div className="card-a">
          <div className="icon-wrapper-a">
            <FaDollarSign className="icon-a" />
          </div>
          <h3>Best Price Guarantee</h3>
          <p>
            We work with trusted travel partners to bring you the best deals,
            whether you're booking a flight, hotel, or car rental.
          </p>
        </div>
        <div className="card-a">
          <div className="icon-wrapper-a">
            <FaHeadset className="icon-a" />
          </div>
          <h3>Customer Support</h3>
          <p>
            Our dedicated support team is here for you 24/7, ensuring your travel
            plans go smoothly from start to finish.
          </p>
        </div>
        <div className="card-a">
          <div className="icon-wrapper-a">
            <FaSuitcase className="icon-a" />
          </div>
          <h3>Tailored Travel Experiences</h3>
          <p>
            Whether you're traveling for business, family vacations, or a solo
            adventure, we provide options that suit every need.
          </p>
        </div>
      </div>
      <div className="bg-star-bottom">
            <img src={bgBottom} alt="" />
        </div>
    </div>
  );
};

export default WhyChooseUs;
